import { Routes } from '@angular/router';
import { dashboardRoutes } from '../features/dashboard/dashboard-routes';
import { clientsRoutes } from '../features/clients/clients-routes';
import { timeTrackerRoutes } from '../features/time-tracker/time-tracker-routes';
import { reportsRoutes } from '../features/reports/reports-routes';
import { profileRoutes } from '../features/profile/profile-routes';
import { workItemsRoutes } from '../features/work-items/work-items.routes';
import { timesheetRoutes } from '../features/timesheet/timesheet-routes';
import { workspaceRoutes } from '../features/workspace/workspace.routes';

export const layoutRoutes: Routes = [
  ...dashboardRoutes,
  ...clientsRoutes,
  ...workItemsRoutes,
  ...reportsRoutes,
  ...timesheetRoutes,
  ...timeTrackerRoutes,
  ...workspaceRoutes,
  ...profileRoutes,
];
